export default __webpack_public_path__ + "static/media/peugot301.93d2ad43.png";